// Re-export domain language utilities for admin application
export {
  getAllLanguagesInfo,
  getLanguageInfo,
  SupportedLanguages,
  isSupportedLanguage,
  type LanguageCode,
  type LanguageInfo,
} from "@lingoshade/domain";

// Legacy compatibility - map domain types to old format
import {
  getAllLanguagesInfo as getDomainLanguages,
  getLanguageInfo as getDomainLanguageInfo,
} from "@lingoshade/domain";

import type { LanguageCode as DomainLanguageCode } from "@lingoshade/domain";

export const SUPPORTED_LANGUAGES = getDomainLanguages();

// Export language codes only
export const LANGUAGE_CODES = SUPPORTED_LANGUAGES.map((lang) => lang.code);

// Helper function to get language name by code
export const getLanguageName = (code: string): string => {
  try {
    return getDomainLanguageInfo(code as DomainLanguageCode).name;
  } catch {
    return code;
  }
};

// Helper function to get native language name by code
export const getNativeLanguageName = (code: string): string => {
  try {
    return getDomainLanguageInfo(code as DomainLanguageCode).nativeName;
  } catch {
    return code;
  }
};

// Type definitions for TypeScript (legacy compatibility)
export interface Language {
  code: string;
  name: string;
  nativeName: string;
}

// LanguageCode is re-exported from @lingoshade/domain (line 7)
